<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="编码/名称">
              <a-input v-model.trim="queryParam.codeAndName" placeholder=""/>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <!--<a-col :md="4" :sm="24">
              <a-form-item label="是否免审">
                <a-select v-model="queryParam.fromAudit" placeholder="请选择" >
                  <a-select-option value="1">是</a-select-option>
                  <a-select-option value="0">否</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->

            <a-col :md="6" :sm="24">
              <a-form-item label="业务员">
                <a-input v-model.trim="queryParam.username" placeholder=""/>
              </a-form-item>
            </a-col>
  
            <!-- <a-col :md="4" :sm="24">
              <a-form-item label="等级">
                <a-select v-model="queryParam.level" placeholder="请选择" >
                  <a-select-option value="A">A</a-select-option>
                  <a-select-option value="B">B</a-select-option>
                  <a-select-option value="C">C</a-select-option>
                  <a-select-option value="D">D</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item label="区域编号">
                <a-input-number v-model="queryParam.areaOneAndTwoCode" style="width: 100%"/>
              </a-form-item>
            </a-col> -->

          <!--   <a-col :md="8" :sm="24">
              <a-form-item label="起止日期"
                           :labelCol="{lg: {span: 7}, sm: {span: 7}}"
                           :wrapperCol="{lg: {span: 10}, sm: {span: 17} }">
                <a-range-picker v-model="queryParam.createTime" style="width: 100%"
                                showTime format="YYYY-MM-DD"/>
              </a-form-item>
            </a-col> -->


          </template>

          <a-col :md="!advanced && 4 || 4" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            <!--   <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>

      <a-upload
        accept=".xls,.xlsx"
        :showUploadList="false"
        :action= "config.importSupplierUrl"
        :beforeUpload="beforeUpload"
        @change="handleChange"
      >
        <a-button style="margin-left: 8px" type="primary" icon="plus" >导入</a-button>
      </a-upload>
      <a-button style="margin-left: 8px" type="primary" @click="downLoad()">模板下载</a-button>
      <a-button style="margin-left: 8px" type="primary" @click="handleExport()">导出</a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 2000 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
    <span slot="serial" slot-scope="text, record, index">
      {{ index + 1 }}
      <span class="blacktr" v-if="blackListOpen && $store.getters.blackList['5'] && $store.getters.blackList['5'][record.id]">
      </span>
    </span>

     <!-- <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a v-if="blackListOpen && (!$store.getters.blackList['5'] || !$store.getters.blackList['5'][record.id])" 
          @click="handleBlack(record)">拉黑</a>
        <span v-else>已黑</span>
         <a-dropdown>
          <a class="ant-dropdown-link"> 更多<a-icon type="down"/></a>
          <a-menu slot="overlay">
            <a-menu-item><a @click="handleAccredit(record)">拉黑</a></a-menu-item>
            <a-menu-item><a @click="handleDel(record)">删除</a></a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>-->


      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical"/>
        <a-dropdown >
          <a class="ant-dropdown-link"> 更多<a-icon type="down"/></a>
          <a-menu slot="overlay">
            <a-menu-item v-if="blackListOpen">
            <a v-if="blackListOpen && (!$store.getters.blackList['5'] || !$store.getters.blackList['5'][record.id])" @click="handleBlack(record)">拉黑</a>
            <span v-else>已黑</span></a-menu-item>
            <a-menu-item><a @click="handleDel(record)">删除</a></a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>

    <a-modal
      title="操作"
      style="top: 10px;"
      :width="800"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item label="名称" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="供用商名称" v-decorator="['name', { initialValue: mdl.name, rules: [{ required: true, message: '请输入供用商名称'}]}]"/>
        </a-form-item>

        <a-form-item label="编码" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="供用商编码" v-model="mdl.code"/>
        </a-form-item>

        <a-form-item label="等级" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select v-model="mdl.level"  placeholder="请选择" >
            <a-select-option v-for="(item, index) in levelSelect" :key="index" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="供应商联系人" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="供应商联系人" v-model="mdl.linkMan"/>
        </a-form-item>

        <a-form-item
          label="联系人电话"
          :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
        >
          <a-input placeholder="联系人电话" v-model="mdl.linkManPhone" v-decorator="['linkManPhone', { initialValue: mdl.linkManPhone, rules: [{ required: false,max:11, message: '请输入正确格式长度手机号码'}]}]" @blur="validatePhoneBlur"/>
        </a-form-item>

        <!--<a-form-item label="业务员" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" >
       <!-- <a-form-item label="业务员" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" >
          <a-select :filterOption="filterOption" v-model="mdl.userId" placeholder="请选择">
            <a-select-option v-for="(item, index) in userSelect" :key="index" :value="item.id">{{ item.username }}</a-select-option>
          </a-select>
        </a-form-item>-->

        <a-form-item label="采购员" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select :filterOption="filterOption" v-model="mdl.purchaserId" placeholder="请选择">
            <a-select-option v-for="(item, index) in userSelect" :key="index" :value="item.id">{{ item.username }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="所属区域1" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="所属区域1" v-model="mdl.areaOne" />
        </a-form-item>

        <a-form-item label="所属区域2":label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="所属区域2" v-model="mdl.areaTwo" />
        </a-form-item>

        <a-form-item label="区域编码1":label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="区域编码1" v-model="mdl.areaOneCode" />
        </a-form-item>

        <a-form-item label="区域编码2" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input placeholder="区域编码2" v-model="mdl.areaTwoCode" />
        </a-form-item>

        <!-- <a-form-item
        label="是否免审"
        validateStatus="warning"
        :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }"
      >
        <a-select placeholder="请选择" v-model="mdl.fromAudit" v-decorator="['fromAudit', { initialValue: mdl.fromAudit, rules: [{ required: true, message: '请选择是否免审'}]}]">
          
          <a-select-option value="1">是</a-select-option>
          <a-select-option value="0">否</a-select-option>
        </a-select>
      </a-form-item>-->

      </a-form>
    </a-modal>

    <a-modal
      title="拉黑"
      :width="640"
      v-model="blackModel" @ok="handleBlackOk" 
      :confirmLoading="confirmLoading">
      <a-form :form="form">
        <a-form-item label="企业名" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" >
          <a-input disabled placeholder="企业名" v-model="black.name" id="role_name" />
        </a-form-item>

        <a-form-item label="类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" >
          <a-select disabled v-model="black.type" placeholder="请选择" >
            <a-select-option v-for="(item, index) in typeSelect" :key="index" :value="item.value">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="拉黑原因" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }" >
          <a-textarea :rows="1" v-model="black.remark" placeholder="..." id="describe" 
            v-decorator="['remark',
            { initialValue: black.remark, rules: [{ required: true, message: '请输入拉黑原因'}]}]"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import { STable } from '@/components'
  import { getCorpSupplierPage, corpSupplierDelete, corpSupplierSave, corpSupplierUpdate ,corpSupplierSyncData} from '@/api/basic'
  import { blackListSave } from '@/api/basic'
  import { userList } from '@/api/sys'
  import { formatDate } from '@/utils/date'
  import Bus from '@/layouts/bus'
  import config from '@/config/defaultSettings'

  export default {
    name: 'CorpSupplier',
    components: {
      STable
    },
    data () {
      return {
        pageSizeOptionsList:['10'],
        description: '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
        visible: false,
        confirmLoading: false,
        blackModel: false,
        form: this.$form.createForm(this),
        mdl: {},
        black: {},
        blackListOpen: config.blackListOpen,
        
        // 高级搜索 展开/关闭
        advanced: true,
        // 查询参数
        queryParam: {},
        loading:false,
        // 表头
        columns: [
          {
            title: '#',
            scopedSlots: { customRender: 'serial' },
            width: '40px',
            fixed: 'left'
          },
          {
            title: '名称',
            dataIndex: 'name',
            width: '340px',
          },
          {
            title: '编号',
            dataIndex: 'code',
            width: '250px',
          },
          {
            title: '等级',
            dataIndex: 'level',
            width: '150px',
          },
          {
            title: '供应商联系人',
            dataIndex: 'linkMan',
            width: '170px',
          },
          {
            title: '联系人电话',
            dataIndex: 'linkManPhone',
            width: '150px',
          },
         /* {
            title: '业务员',
            dataIndex: 'username',
            width: '140px',
          },*/
          {
            title: '采购员',
            dataIndex: 'purchaserName',
            width: '140px',
          },
          {
            title: '所属区域1',
            dataIndex: 'areaOne',
            width: '145px',
          },
          {
            title: '所属区域2',
            dataIndex: 'areaTwo',
            width: '150px',
          },
          {
            title: '区域编码1',
            dataIndex: 'areaOneCode',
            width: '150px',
          },
          {
            title: '区域编码2',
            dataIndex: 'areaTwoCode',
            width: '160px',
          },
          {
          title: '创建人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
          {
            title: '操作',
            width: '130px',
            fixed: 'right',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 所属菜单下拉
        userSelect: null,
        typeSelect: null,
        levelSelect: null,
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          if (this.queryParam.createTime !== undefined && this.queryParam.createTime.length > 1) {
            this.queryParam['startTime'] = formatDate(new Date(this.queryParam.createTime[0]), 'yyyy-MM-dd hh:mm:ss')
            this.queryParam['endTime'] = formatDate(new Date(this.queryParam.createTime[1]), 'yyyy-MM-dd hh:mm:ss')
          }
          return getCorpSupplierPage(Object.assign(parameter, this.queryParam))
            .then(res => {
              setTimeout(() => {
                $('.blacktr').parents('tr').css("background-color", "#ddd")
              }, 1000);
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],

        options: {
          alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        optionAlertShow: true
      }
    },
    created () {
      this.tableOption()
      this.loadUserSelect()
    },
    mounted() {
      // setTimeout(() => {
      //   $('.blacktr').parents('tr').css("border-left", "10px solid #000")
      // }, 1000);
    },
    methods: {
      validatePhoneBlur(e) {
        const validatePhoneReg = /^1[3456789]\d{9}$/
        if (e.target.value && !validatePhoneReg.test(e.target.value)) {
          const arr = [{
            message: '您输入的手机格式不正确!',
            field: 'linkManPhone',
          }]
          this.form.setFields({ linkManPhone: { value: e.target.value, errors: arr } })
        }
      },
      loadUserSelect () { // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = userList({ }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.userSelect = res
        })
        this.typeSelect = this.$store.getters.codeList.basic_black_list_type
        this.levelSelect = this.$store.getters.codeList.basic_corp_level
       
      },
      filterOption (input, option) { // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      tableOption () {
        if (!this.optionAlertShow) {
          this.options = {
            alert: { show: false, clear: () => { this.selectedRowKeys = [] } },
            rowSelection: {
              selectedRowKeys: this.selectedRowKeys,
              onChange: this.onSelectChange
            }
          }
          this.optionAlertShow = true
        } else {
          this.options = {
            alert: false,
            rowSelection: null
          }
          this.optionAlertShow = false
        }
      },

      handleEdit (record) {
        this.mdl = Object.assign({}, record)
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.visible = true
      },

      handleAdd () {
        this.mdl = {}
        //每次打开弹窗之前重置下form表单
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.visible = true
      },
      handleOk () {
        // 手机号验证
        var linkManPhone=this.mdl.linkManPhone
        const validatePhoneReg = /^1[3456789]\d{9}$/
        if (linkManPhone && !validatePhoneReg.test(linkManPhone)) {
          const arr = [{
            message: '您输入的手机格式不正确!',
            field: 'linkManPhone',
          }]
          this.form.setFields({ linkManPhone: { value: linkManPhone, errors: arr } })
          return
        }
        this.form.validateFields((err, values) => {
          Object.assign(this.mdl, values)
          if (!err) {
            this.confirmLoading = true
            if (this.mdl.id !== undefined) {
              corpSupplierUpdate(Object.assign({}, this.mdl))
                .then(res => {
                  if (res.code === '0') {
                    this.$refs.table.refresh()
                    this.visible = false
                  }
                }).catch((e) => {
                  console.log(e)
                }).finally(() => {
                  this.confirmLoading = false
                })
            } else {
              corpSupplierSave(Object.assign({}, this.mdl))
                .then(res => {
                  if (res.code === '0') {
                    this.$refs.table.refresh()
                    this.visible = false
                  }
                }).catch((e) => {
                  console.log(e)
                }).finally(() => {
                  this.confirmLoading = false
                })
            }
          }
        })
      },

      handleBlack (record) {
        this.black["type"] = '5'
        this.black["name"] = record.name
        this.black["recordId"] = record.id
        this.black["remark"] = ''
        this.form = this.$form.createForm(this)
        this.blackModel = true
      },

      handleBlackOk ({ commit }) {
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true
            blackListSave(Object.assign({}, this.black))
              .then(res => {
                if (res.code === '0') {
                  let blackList = this.$store.getters.blackList
                  if (!blackList['5'])
                    blackList['5'] = {}
                  blackList['5'][this.black.recordId] = this.black
                  this.$store.commit('SET_BLACK', blackList)
                  this.$refs.table.refresh()
                  this.blackModel = false
                  // setTimeout(() => {
                  //   $('.blacktr').parents('tr').css("border-left", "10px solid #000")
                  // }, 1000);
                } else {
                  this.$message.error(res.message)
                }
              }).catch((e) => {
                console.log(e)
              }).finally(() => {
                this.confirmLoading = false
              })
          }
        })
      },

      handleDel (record) {
        var nthis = this
        this.$confirm({
          title: '提示',
          content: '确定要删除吗?',
          onOk () {
            nthis.confirmLoading = true
            return corpSupplierDelete(Object.assign(record, nthis.queryParam))
              .then(res => {
                if (res.code === '0') {
                  nthis.$refs.table.refresh()
                }
              }).catch((e) => {
                console.log(e)
              })
          },
          onCancel () {
          }
        })
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      handleChange (info) {
        if (info.file.status === 'uploading') {
          Bus.$emit('showSpinning', true, "准备导入...")
        }

        if (info.file.status === 'done') {
          Bus.$emit('showSpinning', false)
          if (info.file.response && info.file.response.code === '0'){
            this.$message.success('导入成功！')
            this.$refs.table.refresh()
          }else{
            this.$message.error(info.file.response.message)
          }
        }
      },
      beforeUpload (file) {

      },
      downLoad(){
        let url=this.config.downLoadMouldUrl+"供应商.xlsx"
        window.location.href=url
      },
      handleExport() {
        var codeAndName=this.queryParam.codeAndName
        var username=this.queryParam.username
        if(!codeAndName){
          codeAndName=''
        }
        if(!username){
          username=''
        }
        const token = Vue.ls.get(ACCESS_TOKEN)
        window.location.href = this.config.downloadCorpSupplierUrl + '&accessToken=' + token +'&codeAndName=' +codeAndName +'&username=' +username
      },
    },
    watch: {

    },

  }

</script>
